import { ReactElement, useEffect, useRef, useState } from 'react';
import '../styles/basic.css';

export function ASCII (props : {id : string, ascii : string, size ?: number, className ?: string})
{
    const [lines, setLines] = useState<ReactElement[]>([]);
    const width = useRef(0);

    const className = props.className !== undefined ? 'ascii ' + props.className : 'ascii';
    const size = props.size !== undefined ? props.size : 12;
    const h_per_size = size + 1.5;
    const w_per_char = size * 7.2015 / 12;

    useEffect(() => {
        fetch (props.ascii)
            .then(r => r.text())
            .then(r => {
                const splitText = r.split('\n');
                const newLines : ReactElement[] = [];
                splitText.forEach ((v, i, a) => {
                    width.current = Math.max(width.current, v.length);
                    newLines.push(<span id={props.id} key={i}>{v}</span>);
                });
                setLines(newLines);
            });
    }, []);
    
    return <div id={props.id} className={className} style={{ fontSize: size, height: lines.length * h_per_size, width: width.current * w_per_char}}>
        { lines }
    </div>
}